<template>
  <div class="timer-container" style="height: 100vh;">
    <!-- <div class="timer-title">Nicole Han 化妆室</div> -->
    <div style="height: 110vh;display: flex;flex-direction:column;justify-content: center;align-items: center;">
      <div class="h1">{{ formattedTime }}</div>
      <div style="font-family: 'DongFangDaKai', sans-serif;font-size: 3em;margin: 0px 0 30px;">Nicole Han Makeup Studio
      </div>
      <div class="controls">
        <div v-if="!isRunning" style="display: flex;align-items: center;" @click="startTimer">
          <img :src="start" alt="reset" />
          <div class="btn" :disabled="isRunning && !isPaused">
            开始计时
          </div>
        </div>
        <div v-else>
          <div v-if="!isPaused" style="display: flex;align-items: center;" @click="pauseTimer">
            <img :src="zanting" alt="reset" />
            <div class="btn" :disabled="!isRunning || isPaused">
              计时暂停
            </div>
          </div>
          <div v-else style="display: flex;align-items: center;" @click="resumeTimer">
            <img :src="jixu" alt="reset" />
            <div :disabled="!isPaused">计时继续</div>
          </div>
        </div>
        <div class="reset" @click="resetTimer">
          <!-- <img :src="reast" alt="reset" /> -->
          <div class="btn">重置</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeItem",
  data() {
    return {
      time: 0, // 毫秒数
      timer: null, // 计时器实例
      isRunning: false, // 是否正在运行
      isPaused: false, // 是否暂停
      reast: require("@/assets/reast.png"),
      zanting: require("@/assets/zanting.png"),
      start: require("@/assets/start.png"),
      jixu: require("@/assets/jixu.png"),
    };
  },
  computed: {
    // 格式化显示的时间 (HH:MM:SS)
    formattedTime() {
      const date = new Date(this.time);
      const hours = date.getUTCHours().toString().padStart(2, "0");
      const minutes = date.getUTCMinutes().toString().padStart(2, "0");
      const seconds = date.getUTCSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },
  },
  methods: {
    // 开始计时
    startTimer() {
      if (!this.isRunning) {
        this.isRunning = true;
        this.isPaused = false;
        this.timer = setInterval(() => {
          this.time += 1000; // 每秒增加1000毫秒
        }, 1000);
      }
    },
    // 暂停计时
    pauseTimer() {
      if (this.isRunning && !this.isPaused) {
        clearInterval(this.timer);
        this.isPaused = true;
      }
    },
    // 继续计时
    resumeTimer() {
      if (this.isPaused) {
        this.isPaused = false;
        this.timer = setInterval(() => {
          this.time += 1000;
        }, 1000);
      }
    },
    // 重置计时
    resetTimer() {
      clearInterval(this.timer);
      this.time = 0;
      this.isRunning = false;
      this.isPaused = false;
      this.timer = null;
    },
  },
  // 组件销毁时清除计时器
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.timer-title {
  font-size: 24px;
  color: #000000;
  text-align: center;
}

.timer-container {
  text-align: center;
}

.h1 {
  font-family: 'DongFangDaKai', sans-serif;
  font-size: 7rem;
  color: #000000;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 20px;
}

button {
  padding: 10px 20px;
  margin: 0 10px;
  font-size: 1em;
  cursor: pointer;
  background-color: #f19c9d;
  color: white;
  border: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #f19c9d;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.controls {
  display: flex;
  justify-content: center;
  align-items: center;
}

.controls>div {
  font-size: 1.6rem;
  color: #000000;
  background-color: #fff;
  padding: 15px 25px;
  cursor: pointer;
}

img {
  width: 1.2em;
  height: 1.2em;
  margin-right: 20px;
}

.reset {
  margin-left: 30px;
}

.reset img {
  margin: 0;
}

.reset .btn {
  font-size: 1.6rem;
  color: #000000;
}

/* 小型平板 (600px及以上) */
@media screen and (min-width: 600px) {
  .h1 {
    font-size: 9rem;
  }
}

@media screen and (min-width: 668px) {
  .h1 {
    font-size: 10rem;
  }
}

/* 标准平板 (768px及以上) */
@media screen and (min-width: 768px) {
  .h1 {
    font-size: 12rem;
  }
}

@media screen and (min-width: 968px) {
  .h1 {
    font-size: 15rem;
  }
}

/* 大型平板/小型笔记本 (1024px及以上) */
@media screen and (min-width: 1024px) {
  .h1 {
    font-size: 16rem;
  }
}
</style>
